import React from 'react'
import CommonAddPayout from '../commonfile/CommonAddPayout'
import CustomDivider from '../../shared/utils/CustomDivider'
import CommonAddMarketing from '../commonfile/CommonAddMarketing'

const ZonalCoordinatorAddPTM = () => {
    return (
        <>

            <CommonAddPayout />
            <CustomDivider />
            <CommonAddMarketing/>
        </>
    )
}

export default ZonalCoordinatorAddPTM